export default __webpack_public_path__ + "static/media/ic_trails.01cc14c0.svg";